import { API_URL } from "@/config/config";
import $http from "@/Utils/$http";

const permissionsLink = (params) => `${API_URL}business/${params.businessId}/branches/${params.branchId}/permissions/`;


export const getPermissionsServices = async (params) => (
  await $http.get(permissionsLink(params)+'services', {params})
).data;

export const getPermissionsActions = async (params) => (
  await $http.get(permissionsLink(params)+'actions', {params})
).data;

export const getUserPermissions = async (params) => (
  await $http.get(permissionsLink(params)+'user/'+params.userId, {params})
).data;

export const setUserPermissions = async (params) => (
  await $http.post(permissionsLink(params)+'user/'+params.userId+'/set', params)
).data;